import React, { Fragment } from "react";
import { Button } from "@components";
import type { EditModals } from "./types";

const RevertModal = (props: EditModals) => (
  <Fragment>
    {props.t("REVERT_WARNING")}
    <div className="d-flex justify-content-center pt-5">
      <Button color="secondary" className="w-25 mr-5" onClick={props.onCancel}>
        {props.t("CANCEL")}
      </Button>
      <Button className="w-25" onClick={props.onSubmit}>
        {props.t("REVERT_CHANGES")}
      </Button>
    </div>
  </Fragment>
);

export default RevertModal;
